import { render, staticRenderFns } from "./CurrentAgeChart.vue?vue&type=template&id=7da01f7c"
import script from "./CurrentAgeChart.vue?vue&type=script&lang=ts"
export * from "./CurrentAgeChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports